/**
 * @deprecated The internal use of the tokens is to create a custom theme, don't use the tokens directly from the app.
 */
export default {
    colors: {
        white: '#FFFFFF',
        black: '#000000',
        light: {
            alpha12: 'rgba(255, 255, 255, 0.12)',
            alpha38: 'rgba(255, 255, 255, 0.38)',
            alpha60: 'rgba(255, 255, 255, 0.60)',
            alpha87: 'rgba(255, 255, 255, 0.87)',
        },
        dark: {
            alpha12: 'rgba(0, 0, 0, 0.12)',
            alpha38: 'rgba(0, 0, 0, 0.38)',
            alpha60: 'rgba(0, 0, 0, 0.60)',
            alpha87: 'rgba(0, 0, 0, 0.87)',
        },
        neutral: {
            c50: '#FAFAFA',
            c100: '#FFFFFF',
            c200: '#F7F7F7',
            c300: '#ECECEC',
            c400: '#CECFD1',
            c500: '#788089',
            c600: '#424A52',
            c700: '#282B2F',
            c800: '#2F3440',
            c900: '#1D212A',
            alpha15: 'rgba(0, 0, 0, 0.15)',
            alpha80: 'rgba(0, 0, 0, 0.80)',
        },
        blue: {
            c90: '#2396FE',
            c100: '#0086FF',
            c110: '#0079E6',
        },
        green: {
            c90: '#1BC250',
            c100: '#08A93C',
            c110: '#008F2D',
        },
        violet: {
            c90: '#B744E2',
            c100: '#A400E1',
            c110: '#8B00BF',
        },
        yellow: {
            c90: '#FEDA3D',
            c100: '#FFC700',
            c110: '#E4B50A',
        },
        red: {
            c90: '#FA5A72',
            c100: '#E12A45',
            c110: '#C70E2A',
        },
    },
    spacing: {
        zero: 0,
        xxsmall: 4,
        xsmall: 8,
        small: 12,
        medium: 16,
        large: 20,
        xlarge: 24,
        xxlarge: 40,
        xxxlarge: 56,
        hude: 72,
    },
    shadow: {
        dp0: 'none',
        dp1: '0px 3px 1px -2px rgba(120, 128, 137, 0.2), 0px 2px 2px rgba(120, 128, 137, 0.14), 0px 1px 5px rgba(120, 128, 137, 0.12)',
        dp2: '0px 3px 3px -2px rgba(120, 128, 137, 0.2), 0px 3px 4px rgba(120, 128, 137, 0.14), 0px 1px 8px rgba(120, 128, 137, 0.12)',
        dp3: '0px 2px 4px -1px rgba(120, 128, 137, 0.2), 0px 4px 5px rgba(120, 128, 137, 0.14), 0px 1px 10px rgba(120, 128, 137, 0.12)',
        dp4: '0px 3px 5px -1px rgba(120, 128, 137, 0.2), 0px 5px 8px rgba(120, 128, 137, 0.14), 0px 1px 14px rgba(120, 128, 137, 0.12)',
    },
    radii: {
        sharp: 0,
        semiRounded: 6,
        rounded: 9,
        circle: 9999,
    },
    border: {
        zero: 0,
        small: 1,
        medium: 2,
        large: 4,
    },
    fontFamily: {
        magalu: "'Magalu', 'MagaluTextos', sans-serif",
    },
    fontWeight: {
        regular: 400,
        medium: 500,
        bold: 700,
        xbold: 900,
    },
    fontSize: {
        default: 16,
        xsmall: 12,
        small: 14,
        medium: 20,
        large: 26,
        xlarge: 32,
        xxlarge: 40,
        xxxlarge: 48,
    },
    lineHeight: {
        default: 24,
        xsmall: 18,
        small: 24,
        medium: 30,
        large: 36,
        xlarge: 42,
        xxlarge: 46,
        xxxlarge: 52,
    },
    typography: {
        xsmall: {
            fontFamily: 'Magalu',
            fontSize: 12,
            letterSpacing: 0,
            lineHeight: 18,
        },
        small: {
            fontFamily: 'Magalu',
            fontSize: 14,
            letterSpacing: 0,
            lineHeight: 24,
        },
        default: {
            fontFamily: 'Magalu',
            fontSize: 16,
            letterSpacing: 0,
            lineHeight: 24,
        },
        medium: {
            fontFamily: 'Magalu',
            fontSize: 20,
            letterSpacing: 0,
            lineHeight: 30,
        },
        large: {
            fontFamily: 'Magalu',
            fontSize: 26,
            letterSpacing: 0,
            lineHeight: 36,
        },
        xlarge: {
            fontFamily: 'Magalu',
            fontSize: 32,
            letterSpacing: 0,
            lineHeight: 42,
        },
        xxlarge: {
            fontFamily: 'Magalu',
            fontSize: 40,
            letterSpacing: 0,
            lineHeight: 46,
        },
        xxxlarge: {
            fontFamily: 'Magalu',
            fontSize: 48,
            letterSpacing: 0,
            lineHeight: 52,
        },
    },
};
